import Buttons from '@/component/popups/Buttons';
import FrameTreasure from '@/component/popups/ui-2';
import coinImg from '@assets/web-v3-images/icons/crown-coin-icon.png';
import { Text } from '@radix-ui/themes';

export default function Congratulation({
	onOpenChange,
	open,
	handleClick,
	textBtn = '',
	textDescribe = 'Lorem ipsum',
	valueCoin,
	title = "",
	imgs = ''
}) {
	return (
		<FrameTreasure
			open={open}
			onOpenChange={onOpenChange}
			hiddenIconExit={false}
			title={title}
		>
			<Text
				as="p"
				className="
					w-full
					text-center
					text-[#FEF7C3]
					font-bold
					text-[16px]
					md:text-[18px]
					px-5 sm:px-13
    			"
			>
				{textDescribe}
			</Text>
			{valueCoin &&
				<div className='flex gap-2 items-center justify-center py-4 relative z-10'>
					<img src={coinImg} alt="coin" className='h-full w-10 sm:w-12' />
					<span
						className='font-extrabold text-[30px] sm:text-[40px]'
						style={{
							backgroundImage: `
						linear-gradient(
							180deg,
							rgba(254, 247, 195, 1) 0%,
							rgba(254, 247, 195, 1) 40%,
							rgba(253, 226, 114, 1) 50%,
							rgba(254, 247, 195, 1) 60%,
							rgba(254, 247, 195, 1) 100%
						)
					`,
							WebkitBackgroundClip: "text",
							backgroundClip: "text",
							color: "transparent",
							WebkitTextStroke: "1px rgba(234, 170, 8, 1)",
							paintOrder: "stroke fill",
							filter: "drop-shadow(0 4px 4px rgba(0, 0, 0, 0.25))",
						}}
					>
						{valueCoin}
					</span>
				</div>
			}
			<div className="relative w-full ">
				<img
					src={imgs}
					alt="100"
					className="block w-full h-auto -mt-[80px] sm:-mt-[100px]"
				/>
				{textBtn &&
					<div className='px-[20%] absolute bottom-3'>
						<Buttons handleClick={handleClick} textBtn={textBtn} />
					</div>
				}
			</div>
		</FrameTreasure>
	)
}
